/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as React from 'react';

import { IMandsHomepageBannerData } from './mands-homepage-banner.data';
import { IMandsHomepageBannerProps } from './mands-homepage-banner.props.autogenerated';
import { RichTextComponent } from '@msdyn365-commerce/core';
/**
 *
 * MandsHomepageBanner component
 * @extends {React.PureComponent<IMandsHomepageBannerProps<IMandsHomepageBannerData>>}
 */
export default class MandsHomepageBanner extends React.PureComponent<IMandsHomepageBannerProps<IMandsHomepageBannerData>> {
    public render(): JSX.Element {
        // const { config: { bannerContent, bannerImage, infoLinks } } = this.props;
        const {
            config: { bannerContent, infoLinks }
        } = this.props;

        return (
            <div className='covid_banner_inner'>
                <div className='banner_left_container'>
                    <div className='banner_together'>
                        {/* {bannerImage && <img src={bannerImage.src} alt={bannerImage.altText} />} */}
                        <img
                            src='https://asset2.cxnmarksandspencer.com/is/image/mands/1026_20200327_icon_Together?fmt=png-alpha'
                            alt='Mark and Spencer'
                        />
                    </div>
                </div>
                <div className='banner_right_container'>
                    <div className='banner_right_inner'>
                        {bannerContent && <RichTextComponent text={bannerContent} />}
                        <p className='info_links'>
                            {infoLinks &&
                                infoLinks.map(infoLink => {
                                    return (
                                        infoLink &&
                                        infoLink.linkText && (
                                            <span>
                                                <a href={infoLink.linkUrl.destinationUrl}>{infoLink.linkText}</a>
                                            </span>
                                        )
                                    );
                                })}
                        </p>
                    </div>
                </div>
            </div>
        );
    }
}
